import { render, staticRenderFns } from "./PunchinStatistics.vue?vue&type=template&id=f8aa9af2&scoped=true"
import script from "./PunchinStatistics.vue?vue&type=script&lang=js"
export * from "./PunchinStatistics.vue?vue&type=script&lang=js"
import style0 from "./PunchinStatistics.vue?vue&type=style&index=0&id=f8aa9af2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8aa9af2",
  null
  
)

export default component.exports